module.exports = __webpack_public_path__ + "static/media/aviso_privacidad_2_2.2f11a40a.pdf";